import React from 'react';
import { MapPinned, ShieldCheck, Users, Wrench } from 'lucide-react';
import { CTAButton, PageHero, SectionLabel } from '../components/shared';
export function About() {
  return <>
      <PageHero eyebrow="About Watchdog" title="Local people. Real installs. Modern systems." subtitle="Watchdog Security is a Folsom-based team designing and supporting commercial and residential security across Northern California." data-id="element-142">
        <CTAButton to="/contact" data-id="element-143">Talk to our team</CTAButton>
      </PageHero>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-id="element-144">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center" data-id="element-145">
          <div data-id="element-146">
            <SectionLabel data-id="element-147">Why we exist</SectionLabel>
            <h2 className="text-4xl font-black tracking-tight sm:text-5xl" data-id="element-148">
              Security should not feel like a tangle of vendors.
            </h2>
            <p className="mt-6 leading-8 text-slate-600" data-id="element-149">
              Most properties end up with one camera company, one alarm company,
              one lock vendor, and a separate person for repairs. Watchdog
              brings it all together — modern Alarm.com technology, installed
              and supported by a local team that knows your name and your
              property.
            </p>
            <p className="mt-4 leading-8 text-slate-600" data-id="element-150">
              We are based in Folsom and serve businesses and homeowners across
              Northern California with commercial-grade systems, smart home
              protection, and ongoing support.
            </p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2" data-id="element-151">
            {([[ShieldCheck, 'Alarm.com powered', 'Industry-leading platform.'], [MapPinned, 'Local technicians', 'Folsom-based, NorCal coverage.'], [Users, 'Dedicated support', 'Real people answer your call.'], [Wrench, 'Repairs and upgrades', 'We service most major systems.']] as const).map(([Icon, title, text]) => <div key={title} className="rounded-3xl border border-slate-200 bg-slate-50 p-6" data-id="element-152">
                <Icon className="mb-4 h-7 w-7 text-sky-500" data-id="element-153" />
                <p className="font-black" data-id="element-154">{title}</p>
                <p className="mt-2 text-sm leading-6 text-slate-600" data-id="element-155">{text}</p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="bg-sky-50 py-16" data-id="element-156">
        <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8" data-id="element-157">
          <h2 className="text-3xl font-black sm:text-4xl" data-id="element-158">
            Visit us in Folsom or have us come to you.
          </h2>
          <p className="mx-auto mt-4 max-w-2xl leading-8 text-slate-600" data-id="element-159">
            1021 Kirby Ct, Folsom, CA 95630 — open 7 days a week. Most
            assessments happen on-site at your property at no cost.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-160">
            <CTAButton to="/contact" data-id="element-161">Contact us</CTAButton>
            <CTAButton variant="dark" href="tel:+19168424729" data-id="element-162">
              Call (916) 842-4729
            </CTAButton>
          </div>
        </div>
      </section>
    </>;
}